import styled from 'styled-components'

export const DateField = styled.div``
